module.exports = __webpack_public_path__ + "static/media/dusting.2b07551a.png";